
var createReactClass = require('create-react-class');
import React from 'react';
import Modal from '../Modal';

const SpecialtiesModal = createReactClass({
  getInitialState: function() {
    return({
      specialties: this.props.specialties
    })
  },

  mapSpecialties: function() {
    var self = this;
    return this.props.specialtyIds.map(function(id) {
      var el = self.state.specialties[id]
      return(
          <label key={el.id}>
            <input type='checkbox' onChange={function(){ self.handleChange(el.id)}} checked={el.checked}/>
            &nbsp;{el.name}
          </label>
      )
    })
  },

  handleChange: function(spId) {
    var self = this;
    var updatedSpecialties = self.state.specialties;
    updatedSpecialties[spId].checked = !updatedSpecialties[spId].checked
    self.setState({specialties: updatedSpecialties}, function(){self.props.handleChange(updatedSpecialties)});
  },

  handleClose: function() {
      Modal.close({onCloseInstant: this.props.resetPage});
  },

  render: function(){
    return(
      <div data-reveal  className='cureus-custom-multi-select-modal reveal-modal'>
        <div className='modal-heading'>
          <div className='modal-title'>
            Select one or more specialties.
          </div>
          <div className='modal-close'>
            <a href='#' className='tiny button' onClick={this.handleClose} style={{height: 'auto', width: 'auto'}}>
              Filter
            </a>
          </div>
        </div>
        <div className='modal-body-wrap'>
          <div className='modal-body'>
            <div className='modal-content'>
              {this.mapSpecialties()}
            </div>
          </div>
        </div>
      </div>
    )
  }
});

export default SpecialtiesModal;
